/* global apigClientFactory angular */
import { get } from 'lodash';

/* @ngInject */
export default class {
  constructor($q, $log, $state, $stateParams, $window, JwtClass, UserClass, ApiClass, Swal) {
    this.JwtClass = JwtClass;
    this.UserClass = UserClass;
    this.ApiClass = ApiClass;
    this.Swal = Swal;
    this.$q = $q;
    this.$log = $log;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$window = $window;
    this._request = false;
    this._request_error = false;
    this.apigClientFactory = apigClientFactory.newClient();
    this.user_profile = {};
    this.profile_complete = {};
    this.alerts = [];
    this.userAlerts = [];
    this.email = null;
    this.errors = false;
    this.loggedIn = false;
  }

  get profileComplete() {
    return this.profile_complete;
  }

  get company_id() {
    return get(this.profile_complete, 'profile.company_id', 1);
  }

  get profile_uid() {
    return get(this.profile_complete, 'profile.profile_uid', undefined);
  }

  get userProfile() {
    return this.user_profile;
  }

  get userEmail() {
    return this.email;
  }

  errors() {
    return this.errors;
  }

  resetClass() {
    this._request = false;
    this._request_error = false;
    this.loggedIn = false;
    this.user_profile = {};
    this.profile_complete = {};
    this.email = null;
    this.errors = false;
    return this.$q.resolve(true);
  }

  clearQueryStringAlert() {
    const search = this.$stateParams;
    search.alertType = undefined;
    search.alertValue = undefined;

    this.$state.go('.', search);
  }

  setQueryStringAlert() {
    const { alertType, alertValue } = this.$stateParams;

    if (alertType) {
      this.alerts.push({ type: alertType, value: alertValue });
      this.clearQueryStringAlert();
    }
  }

  updateAlerts() {
    this.alerts.length = 0;

    this.alerts.push(...this.userAlerts);
    this.setQueryStringAlert();
  }

  loadUser(Authorization, update) {
    if (this.$window.opener && this.$window.name === 'Sign-In/Sign-Up') {
      this.$window.close();
    }

    if (!update && (this._request && !this._request_error)) {
      return this._request;
    }

    this._request = this.$q((resolve, reject) => {
      if (!Authorization) return reject(new Error('Missing Token'));
      this.apigClientFactory
        .usersPut({ manage: false }, {}, { headers: { Authorization } })
        .then(({ data: { item: profile } }) => {
          if (profile) {
            angular.copy(profile, this.user_profile);
            this.email = profile.email;
            const qArr = [
              this.profileGet(profile.profile_uid),
              this.UserClass.setRoles(profile),
              this.ApiClass.companiesIdGet(
                {
                  manage: false,
                  id: profile.company_id || 1
                },
                null,
                {
                  queryParams: {
                    hasPublishedForms: true
                  }
                }
              )
            ];
            // eslint-disable-next-line no-unused-vars
            return this.$q.all(qArr).then(([alertsSet, roleSet, { data: { company, hasPublishedForms } }]) => {
              company.hasPublishedForms = hasPublishedForms;
              this.profile_complete = { profile };
              this.profile_complete.company = company;
              this.loggedIn = true;

              this._request_error = false;
              resolve(profile);
            });
          }
        })
        .catch(error => {
          this._request_error = true;
          if (error.data && error.data.description === 'The user account has been deactivated.') {
            this.Swal.alert(
              'Hold up!',
              'Your profile has been deactivated by the account administrator.  If you think this was in error or would like your account information migrated to a new email, please contact your account administrator or contact support@prolaera.com.',
              'warning',
              20000
            );
          }
          this.$log.error(error);
          reject(error);
        });
    });

    return this._request;
  }

  profileGet(profile_uid) {
    this.userAlerts.length = 0;

    return this.ApiClass.usersIdGet({ id: profile_uid, manage: false }, null, {
      queryParams: { 'include:invites': true }
    }).then(result => {
      const {
        data: { item, invites }
      } = result;

      // Start to build profile userAlerts;
      if (invites) {
        invites.forEach(invite => {
          invite.type = 'invite';
          this.userAlerts.push(invite);
        });
      }

      return item;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/ProfileClass.js